import { useSiteMedia } from "@/context/SiteMediaContext";
import { useEffect, useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api, API } from "@/lib/api";


const TESTIMONIALS = [
  { name: "Sophie M.", pt: "Um atendimento incrível, tratamentos de grande qualidade e resultados visíveis.", fr: "Un accueil incroyable, des soins de grande qualité et des résultats visibles." },
  { name: "Julie R.", pt: "Carolina é atenciosa e muito profissional. Minha pele nunca esteve tão bonita.", fr: "Carolina est attentionnée et très professionnelle. Ma peau n'a jamais été aussi belle." },
  { name: "Amandine L.", pt: "Um verdadeiro momento de bem-estar a cada visita.", fr: "Un vrai moment de bien-être à chaque visite." },
];

export default function Results() {
  const media = useSiteMedia();
  const { T, lang } = useLanguage();
  const [results, setResults] = useState([]);

  useEffect(() => {
    api.get("/public/results").then((r) => setResults(r.data)).catch(() => {});
  }, []);

  const pairs = results.length > 0
    ? results.map((r) => ({ id: r.id, title: r.title, before: `${API}/public/results/${r.id}/before`, after: `${API}/public/results/${r.id}/after` }))
    : [{ id: "demo", title: "", before: media.results_before_example, after: media.results_after_example }];

  return (
    <div className="pt-16 pb-10 px-6 lg:px-16" data-testid="results-page">
      <div className="mb-16 max-w-lg mx-auto text-center">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-3">{T.results.eyebrow}</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-[#9B6179] mb-4">{T.results.page_title}</h1>
        <p className="text-base text-[#090708]/55">{T.results.page_subtitle}</p>
      </div>

      {pairs.map((pair, i) => (
        <div key={pair.id} className="grid grid-cols-1 md:grid-cols-12 gap-6 max-w-[1400px] mx-auto mb-16" data-testid={`result-pair-${i}`}>
          {pair.title && <p className="md:col-span-12 text-[11px] tracking-[0.2em] uppercase text-[#090708]/50 mb-1">{pair.title}</p>}
          <div className="md:col-span-7 aspect-[3/4] overflow-hidden relative">
            <img src={pair.before} className="w-full h-full object-cover" alt="before" />
            <span className="absolute bottom-4 left-4 text-[11px] tracking-widest uppercase text-white bg-[#090708]/70 px-3 py-1.5">{T.results.before}</span>
          </div>
          <div className="md:col-span-5 md:mt-20 aspect-[4/5] overflow-hidden relative">
            <img src={pair.after} className="w-full h-full object-cover" alt="after" />
            <span className="absolute bottom-4 left-4 text-[11px] tracking-widest uppercase text-white bg-[#090708]/70 px-3 py-1.5">{T.results.after}</span>
          </div>
        </div>
      ))}

      <div className="max-w-2xl mx-auto mt-12">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-10 text-center">{T.results.testimonials_title}</p>
        <div className="flex flex-col divide-y divide-[#090708]/8">
          {TESTIMONIALS.map((t, i) => (
            <div key={i} className="py-7" data-testid={`testimonial-card-${i}`}>
              <p className="font-serif text-xl text-[#090708]/80 leading-relaxed mb-3">"{lang === "pt" ? t.pt : t.fr}"</p>
              <p className="text-[11px] tracking-widest uppercase text-[#9B6179]">{t.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
